import {
  lazy2hsh8ze7j6ikd as lazy,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Long2qws0ah9gnpki as Long,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  CancellationException3b36o9qz53rgr as CancellationException,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  isInterface3d6p8outrmvmk as isInterface,
  printStackTrace18lnx7a39cni as printStackTrace,
  protoOf180f3jzyo7rfj as protoOf,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  coerceIn10f36k81le1mm as coerceIn,
  toShort36kaw0zjdq3ex as toShort,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  shortArrayIteratorvow30nwy4coh as shortArrayIterator,
  Collection1k04j3hzsbod0 as Collection,
  containscs3vsq7ynpxl as contains,
  filll361lpxnd2bw as fill,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  contentDeepHashCodei0atlwkd11sc as contentDeepHashCode,
  contentDeepEquals38knrynwk1e6k as contentDeepEquals,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  KProperty02ce7r476m8633 as KProperty0,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from './kotlin-kotlin-stdlib.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  delay1f60wyf8ua1gc as delay,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  Dispatchers_getInstance2xomc0oxzllw9 as Dispatchers_getInstance,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  launch1c91vkjzdi9sd as launch,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  Deferred6wjx2us769ee as Deferred,
} from './kotlinx-coroutines-core.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from './kotlinx-atomicfu.mjs';
import { Companion_getInstance1yq7a1f60lp2k as Companion_getInstance } from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  FixedPoolNativeThreadDispatcher1vd3m0y3p4oiv as FixedPoolNativeThreadDispatcher,
  Companion_getInstance3o77vcoredkpt as Companion_getInstance_0,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_1,
  cancel1n0qjc93h2v6w as cancel,
  Cancellable3gmnln785cfrg as Cancellable,
} from './korlibs-platform-root-korlibs-platform.mjs';
import { convertRangeClamped599b065i5v6s as convertRangeClamped } from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    var tmp = this;
    tmp.b5r_1 = lazy(AudioData$Companion$DUMMY$delegate$lambda);
  }
}
class AudioData {
  constructor(rate, samples, name) {
    Companion_getInstance_2();
    name = name === VOID ? null : name;
    this.c5r_1 = new Mixin();
    this.d5r_1 = rate;
    this.e5r_1 = samples;
    this.f5r_1 = name;
  }
  cz(_set____db54di) {
    this.c5r_1.cz(_set____db54di);
  }
  dz() {
    return this.c5r_1.dz();
  }
  g5r() {
    return this.e5r_1.h5r_1;
  }
  k5r() {
    return this.e5r_1.i5r_1;
  }
  l5r(channel, sample) {
    return AudioSampleArray__get_impl_w0l0xc(this.e5r_1.j5r_1[channel].m5r_1, sample);
  }
  toString() {
    return 'AudioData(rate=' + this.d5r_1 + ', channels=' + this.g5r() + ', samples=' + this.k5r() + ')';
  }
}
class Companion_0 {
  constructor() {
    this.o5r_1 = 2048;
  }
}
class AudioPlatformOutput$_init_$slambda_5e7gu6 {
  constructor($channels) {
    this.n5r_1 = $channels;
  }
  g5s(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, _this__u8e3s4), $completion);
  }
  wd(p1, $completion) {
    return this.g5s(p1 instanceof AudioPlatformOutput ? p1 : THROW_CCE(), $completion);
  }
}
class AudioPlatformOutput$start$slambda {
  constructor(this$0) {
    this.f5s_1 = this$0;
  }
  h1p($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
  }
  wd(p1, $completion) {
    return this.h1p((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class ReadonlySoundProps {}
function get_pitch() {
  return 1.0;
}
class SoundProps {}
function set_pitch(value) {
  return Unit_instance;
}
function get_pitch_0() {
  return 1.0;
}
class AudioPlatformOutput {
  constructor(listener, channels, frequency, gen, dispatcher, block) {
    dispatcher = dispatcher === VOID ? get_AUDIO(Dispatchers_getInstance()) : dispatcher;
    var tmp;
    if (block === VOID) {
      tmp = AudioPlatformOutput$_init_$slambda_5e7gu6_0(channels);
    } else {
      tmp = block;
    }
    block = tmp;
    this.p5r_1 = new Mixin();
    this.q5r_1 = listener;
    this.r5r_1 = channels;
    this.s5r_1 = frequency;
    this.t5r_1 = gen;
    this.u5r_1 = dispatcher;
    this.v5r_1 = block;
    this.w5r_1 = false;
    var tmp_0 = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp_0.x5r_1 = get_atomicfu$reentrantLock();
    this.y5r_1 = 1.0;
    this.z5r_1 = 0.0;
    this.a5s_1 = Companion_getInstance().t2k_1;
    this.b5s_1 = false;
    this.c5s_1 = null;
    this.d5s_1 = false;
  }
  cz(_set____db54di) {
    this.p5r_1.cz(_set____db54di);
  }
  dz() {
    return this.p5r_1.dz();
  }
  e5s(buffer) {
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.x5r_1;
    try {
      AudioSampleArray__fill$default_impl_gh9lh0(buffer.j5s_1, Companion_getInstance_4().k5s_1);
      this.t5r_1(buffer);
      applyPropsTo(this, this.q5r_1, buffer);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  l5s(_set____db54di) {
    this.y5r_1 = _set____db54di;
  }
  m5s() {
    return this.y5r_1;
  }
  n5s(_set____db54di) {
    this.z5r_1 = _set____db54di;
  }
  o5s() {
    return this.z5r_1;
  }
  e1r() {
    return this.a5s_1;
  }
  p5s($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_suspendWhileRunning__va8tze.bind(VOID, this), $completion);
  }
  q5s() {
    if (this.b5s_1)
      return Unit_instance;
    this.r5s();
    this.d5s_1 = false;
    this.b5s_1 = true;
    var tmp0_safe_receiver = this.c5s_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.j17();
    }
    var tmp = this;
    var tmp_0 = CoroutineScope_0(this.u5r_1.ym(SupervisorJob()));
    tmp.c5s_1 = launch(tmp_0, VOID, VOID, AudioPlatformOutput$start$slambda_0(this));
  }
  r5s() {
    if (!this.b5s_1 && !this.d5s_1)
      return Unit_instance;
    this.d5s_1 = true;
    var tmp1_safe_receiver = this.c5s_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.c5s_1 = null;
      tmp1_safe_receiver.j17();
    }
  }
  g6() {
    return this.r5s();
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.k5s_1 = _AudioSample___init__impl__s54gd5_0(0);
  }
}
class AudioSample {
  constructor(raw) {
    Companion_getInstance_4();
    this.u5s_1 = raw;
  }
  toString() {
    return AudioSample__toString_impl_8zwv0h(this.u5s_1);
  }
  hashCode() {
    return AudioSample__hashCode_impl_cr91se(this.u5s_1);
  }
  equals(other) {
    return AudioSample__equals_impl_tcgo7i(this.u5s_1, other);
  }
}
class AudioSampleArray$iterator$1 {
  constructor($shortIterator) {
    this.w5s_1 = $shortIterator;
  }
  b1() {
    return this.w5s_1.b1();
  }
  x5s() {
    return this.y5s();
  }
  c1() {
    return new AudioSample(this.x5s());
  }
  y5s() {
    return _AudioSample___init__impl__s54gd5(this.w5s_1.m4());
  }
}
class AudioSampleArray {
  constructor(data) {
    this.m5r_1 = data;
  }
  e1() {
    return _AudioSampleArray___get_size__impl__8l8tm8(this.m5r_1);
  }
  g1() {
    return AudioSampleArray__isEmpty_impl_81zmbn(this.m5r_1);
  }
  a1() {
    return AudioSampleArray__iterator_impl_qvmfbu(this.m5r_1);
  }
  z5s(elements) {
    return AudioSampleArray__containsAll_impl_ohplb0(this.m5r_1, elements);
  }
  t2(elements) {
    return AudioSampleArray__containsAll_impl_ohplb0_0(this, elements);
  }
  toString() {
    return AudioSampleArray__toString_impl_il1zfs(this.m5r_1);
  }
  hashCode() {
    return AudioSampleArray__hashCode_impl_363xd3(this.m5r_1);
  }
  equals(other) {
    return AudioSampleArray__equals_impl_jso1e3(this.m5r_1, other);
  }
}
class AudioSamples {
  constructor(channels, totalSamples, data) {
    var tmp;
    if (data === VOID) {
      var tmp_0 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(channels), null);
      while (tmp_0 < channels) {
        var tmp_2 = tmp_0;
        var tmp$ret$1 = _AudioSampleArray___init__impl__qpxoq0_0(totalSamples);
        tmp_1[tmp_2] = new AudioSampleArray(tmp$ret$1);
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_1;
    } else {
      tmp = data;
    }
    data = tmp;
    this.h5r_1 = channels;
    this.i5r_1 = totalSamples;
    this.j5r_1 = data;
  }
  a5t(channel) {
    return this.j5r_1[channel].m5r_1;
  }
  hashCode() {
    return (this.h5r_1 + imul(this.i5r_1, 32) | 0) + imul(contentDeepHashCode(this.j5r_1), 64) | 0;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof AudioSamples) {
      tmp_1 = this.h5r_1 === other.h5r_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.i5r_1 === other.i5r_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentDeepEquals(this.j5r_1, other.j5r_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'AudioSamples(channels=' + this.h5r_1 + ', totalSamples=' + this.i5r_1 + ')';
  }
}
class AudioSamplesInterleaved {
  constructor(channels, totalSamples, data) {
    data = data === VOID ? _AudioSampleArray___init__impl__qpxoq0_0(imul(totalSamples, channels)) : data;
    this.h5s_1 = channels;
    this.i5s_1 = totalSamples;
    this.j5s_1 = data;
    // Inline function 'kotlin.check' call
    var containsArg = this.h5s_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(1 <= containsArg ? containsArg <= 8 : false)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.a5(toString(message));
    }
  }
  l5r(channel, sample) {
    return AudioSampleArray__get_impl_w0l0xc(this.j5s_1, index(this, channel, sample));
  }
  b5t(channel, sample, value) {
    AudioSampleArray__set_impl_tqgfwk(this.j5s_1, index(this, channel, sample), value);
  }
  toString() {
    return 'AudioSamplesInterleaved(channels=' + this.h5s_1 + ', totalSamples=' + this.i5s_1 + ')';
  }
}
class SoundListenerProps {}
function get_listenerPosition() {
  return Companion_getInstance().t2k_1;
}
class NativeSoundProvider {
  constructor() {
    this.c5t_1 = 'unknown';
    this.d5t_1 = false;
    this.e5t_1 = Companion_getInstance().t2k_1;
    this.f5t_1 = Companion_getInstance().v2k_1;
    this.g5t_1 = Companion_getInstance().z2k_1;
    this.h5t_1 = Companion_getInstance().t2k_1;
  }
  s2u(_set____db54di) {
    this.d5t_1 = _set____db54di;
  }
  i5t() {
    return this.e5t_1;
  }
  j5t(channels, frequency, gen) {
    return new AudioPlatformOutput(this, channels, frequency, gen);
  }
  g6() {
  }
}
class DummyNativeSoundProvider extends NativeSoundProvider {
  constructor() {
    Companion_getInstance_5();
    super();
  }
}
class Companion_2 extends DummyNativeSoundProvider {
  constructor() {
    Companion_instance_2 = null;
    super();
    Companion_instance_2 = this;
  }
}
class HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda {
  constructor($frequency, $channels) {
    this.k5t_1 = $frequency;
    this.l5t_1 = $channels;
  }
  g5s($this$AudioPlatformOutput, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$AudioPlatformOutput), $completion);
  }
  wd(p1, $completion) {
    return this.g5s(p1 instanceof AudioPlatformOutput ? p1 : THROW_CCE(), $completion);
  }
}
class HtmlNativeSoundProvider extends NativeSoundProvider {
  constructor() {
    super();
    HtmlSimpleSound_getInstance().r5t();
  }
  j5t(channels, frequency, gen) {
    return new AudioPlatformOutput(this, channels, frequency, gen, VOID, HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda_0(frequency, channels));
  }
}
class sam$korlibs_io_lang_Cancellable$0 {
  constructor(function_0) {
    this.y5t_1 = function_0;
  }
  ft(e) {
    return this.y5t_1(e);
  }
  h4() {
    return this.y5t_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Cancellable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.h4(), other.h4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.h4());
  }
}
class HtmlSimpleSound {
  constructor() {
    HtmlSimpleSound_instance = this;
    var tmp = this;
    var tmp_0;
    try {
      // Inline function 'kotlin.also' call
      var tmp_1;
      // Inline function 'kotlin.js.asDynamic' call
      if (!(typeof window.AudioContext === 'undefined')) {
        tmp_1 = new AudioContext();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        if (!(typeof window.webkitAudioContext === 'undefined')) {
          tmp_1 = new webkitAudioContext();
        } else {
          tmp_1 = null;
        }
      }
      var this_0 = tmp_1;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.audio.sound.HtmlSimpleSound.ctx.<anonymous>' call
      // Inline function 'kotlin.js.asDynamic' call
      window.globalAudioContext = this_0;
      tmp_0 = this_0;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        console.error(e);
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_2;
    }
    tmp.m5t_1 = tmp_0;
    this.n5t_1 = false;
    var tmp_3 = this;
    // Inline function 'kotlin.also' call
    var this_1 = CompletableDeferred();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.sound.HtmlSimpleSound.unlockDeferred.<anonymous>' call
    var buf = ensureNotNull(HtmlSimpleSound_getInstance().m5t_1).createBuffer(1, 1, 22050);
    var unlock = {_v: null};
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var events = ['keydown', 'touchstart', 'touchend', 'mousedown'];
    unlock._v = HtmlSimpleSound$unlockDeferred$lambda(events, unlock, buf, this_1);
    var inductionVariable = 0;
    var last = events.length;
    while (inductionVariable < last) {
      var e_0 = events[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp_4 = document;
      var tmp_5;
      if (unlock._v == null) {
        throwUninitializedPropertyAccessException('unlock');
      } else {
        tmp_5 = unlock._v;
      }
      tmp_4.addEventListener(e_0, tmp_5, true);
    }
    tmp_3.o5t_1 = this_1;
    var tmp_6 = this;
    var tmp_7 = this.o5t_1;
    tmp_6.p5t_1 = isInterface(tmp_7, Deferred) ? tmp_7 : THROW_CCE();
  }
  r5t() {
  }
  q5t(callback) {
    var cancelled = {_v: false};
    this.p5t_1.c17(HtmlSimpleSound$callOnUnlocked$lambda(cancelled, callback));
    var tmp = HtmlSimpleSound$callOnUnlocked$lambda_0(cancelled);
    return new sam$korlibs_io_lang_Cancellable$0(tmp);
  }
}
//endregion
function AudioData$Companion$DUMMY$delegate$lambda() {
  return new AudioData(44100, new AudioSamples(2, 0));
}
var Companion_instance;
function Companion_getInstance_2() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function *_generator_invoke__zhh2q8($this, _this__u8e3s4, $completion) {
  var buffer = new AudioSamplesInterleaved($this.n5r_1, Companion_instance_0.o5r_1);
  while (_this__u8e3s4.b5s_1) {
    _this__u8e3s4.e5s(buffer);
    var tmp = delay(new Long(1, 0), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  try {
    var tmp = $this.f5s_1.v5r_1($this.f5s_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof CancellationException) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  finally {
    $this.f5s_1.b5s_1 = false;
  }
  return Unit_instance;
}
function *_generator_suspendWhileRunning__va8tze($this, $completion) {
  while ($this.b5s_1) {
    var tmp = delay(new Long(10, 0), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
var Companion_instance_0;
function Companion_getInstance_3() {
  return Companion_instance_0;
}
function AudioPlatformOutput$_init_$slambda_5e7gu6_0($channels) {
  var i = new AudioPlatformOutput$_init_$slambda_5e7gu6($channels);
  var l = function (_this__u8e3s4, $completion) {
    return i.g5s(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function AudioPlatformOutput$start$slambda_0(this$0) {
  var i = new AudioPlatformOutput$start$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.h1p($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function _AudioSample___init__impl__s54gd5(raw) {
  return raw;
}
function _get_raw__e6fv55($this) {
  return $this;
}
var Companion_instance_1;
function Companion_getInstance_4() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function _AudioSample___init__impl__s54gd5_0(value) {
  return _AudioSample___init__impl__s54gd5(toShort(coerceIn(value, -32768, 32767)));
}
function _AudioSample___init__impl__s54gd5_1(value) {
  return _AudioSample___init__impl__s54gd5(toShort(coerceIn(numberToInt(value * 32767), -32768, 32767)));
}
function _AudioSample___get_short__impl__uk8ygu($this) {
  return _get_raw__e6fv55($this);
}
function _AudioSample___get_shortInt__impl__jh9fnx($this) {
  return _AudioSample___get_short__impl__uk8ygu($this);
}
function _AudioSample___get_float__impl__o6fgbi($this) {
  return _get_raw__e6fv55($this) / 32767;
}
function AudioSample__times_impl_3gw0k9($this, scale) {
  return _AudioSample___init__impl__s54gd5_0(numberToInt(_AudioSample___get_shortInt__impl__jh9fnx($this) * scale));
}
function AudioSample__toString_impl_8zwv0h($this) {
  return 'AudioSample(raw=' + $this + ')';
}
function AudioSample__hashCode_impl_cr91se($this) {
  return $this;
}
function AudioSample__equals_impl_tcgo7i($this, other) {
  if (!(other instanceof AudioSample))
    return false;
  if (!($this === (other instanceof AudioSample ? other.u5s_1 : THROW_CCE())))
    return false;
  return true;
}
function getSampled(_this__u8e3s4, channel, index) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.memory.getSampledGeneric' call
    var index0 = numberToInt(index);
    // Inline function 'korlibs.audio.sound.getSampled.<anonymous>' call
    var v0 = new AudioSample(_this__u8e3s4.l5r(channel, index0));
    if (index0 === index) {
      tmp$ret$1 = v0.u5s_1;
      break $l$block;
    }
    // Inline function 'korlibs.audio.sound.getSampled.<anonymous>' call
    var it = index0 + 1 | 0;
    var v1 = new AudioSample(_this__u8e3s4.l5r(channel, it));
    var ratio = index % 1.0;
    // Inline function 'korlibs.audio.sound.getSampled.<anonymous>' call
    var sample = v0.u5s_1;
    var scale = 1.0 - ratio;
    var o0 = _AudioSample___get_float__impl__o6fgbi(sample) * scale;
    // Inline function 'korlibs.audio.sound.getSampled.<anonymous>' call
    var sample_0 = v1.u5s_1;
    var o1 = _AudioSample___get_float__impl__o6fgbi(sample_0) * ratio;
    // Inline function 'korlibs.audio.sound.getSampled.<anonymous>' call
    var it_0 = o0 + o1;
    tmp$ret$1 = _AudioSample___init__impl__s54gd5_1(it_0);
  }
  return tmp$ret$1;
}
function _AudioSampleArray___init__impl__qpxoq0(data) {
  return data;
}
function _get_data__d5abxd($this) {
  return $this;
}
function _AudioSampleArray___init__impl__qpxoq0_0(size) {
  return _AudioSampleArray___init__impl__qpxoq0(new Int16Array(size));
}
function _AudioSampleArray___get_size__impl__8l8tm8($this) {
  return _get_data__d5abxd($this).length;
}
function AudioSampleArray__isEmpty_impl_81zmbn($this) {
  // Inline function 'kotlin.collections.isEmpty' call
  return _get_data__d5abxd($this).length === 0;
}
function AudioSampleArray__iterator_impl_qvmfbu($this) {
  var shortIterator = shortArrayIterator(_get_data__d5abxd($this));
  return new AudioSampleArray$iterator$1(shortIterator);
}
function AudioSampleArray__containsAll_impl_ohplb0($this, elements) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(elements, Collection)) {
      tmp = elements.g1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.audio.sound.AudioSampleArray.containsAll.<anonymous>' call
      var it = element.u5s_1;
      if (!AudioSampleArray__contains_impl_pmajf9($this, it)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function AudioSampleArray__containsAll_impl_ohplb0_0($this, elements) {
  return AudioSampleArray__containsAll_impl_ohplb0($this.m5r_1, elements);
}
function AudioSampleArray__contains_impl_pmajf9($this, element) {
  return contains(_get_data__d5abxd($this), _AudioSample___get_short__impl__uk8ygu(element));
}
function AudioSampleArray__get_impl_w0l0xc($this, index) {
  return _AudioSample___init__impl__s54gd5(_get_data__d5abxd($this)[index]);
}
function AudioSampleArray__set_impl_tqgfwk($this, index, value) {
  _get_data__d5abxd($this)[index] = _AudioSample___get_short__impl__uk8ygu(value);
}
function AudioSampleArray__asShortArray_impl_iyd0md($this) {
  return _get_data__d5abxd($this);
}
function AudioSampleArray__fill_impl_cffij3($this, element, fromIndex, toIndex) {
  fill(_get_data__d5abxd($this), _AudioSample___get_short__impl__uk8ygu(element), fromIndex, toIndex);
}
function AudioSampleArray__fill$default_impl_gh9lh0($this, element, fromIndex, toIndex, $super) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _AudioSampleArray___get_size__impl__8l8tm8($this) : toIndex;
  var tmp;
  if ($super === VOID) {
    AudioSampleArray__fill_impl_cffij3($this, element, fromIndex, toIndex);
    tmp = Unit_instance;
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AudioSampleArray(tmp_0)).v5s.call(new AudioSampleArray($this), new AudioSample(element), fromIndex, toIndex);
  }
  return tmp;
}
function AudioSampleArray__toString_impl_il1zfs($this) {
  return 'AudioSampleArray(data=' + toString($this) + ')';
}
function AudioSampleArray__hashCode_impl_363xd3($this) {
  return hashCode($this);
}
function AudioSampleArray__equals_impl_jso1e3($this, other) {
  if (!(other instanceof AudioSampleArray))
    return false;
  var tmp0_other_with_cast = other instanceof AudioSampleArray ? other.m5r_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function index($this, channel, sample) {
  return imul(sample, $this.h5s_1) + channel | 0;
}
function get_AUDIO(_this__u8e3s4) {
  _init_properties_Dispatchers_AUDIO_kt__q7crgv();
  // Inline function 'kotlin.getValue' call
  var this_0 = AUDIO$delegate;
  AUDIO$factory();
  return this_0.n1();
}
var AUDIO$delegate;
function AUDIO$delegate$lambda() {
  _init_properties_Dispatchers_AUDIO_kt__q7crgv();
  var tmp;
  if (Companion_getInstance_1().ov()) {
    tmp = Dispatchers_getInstance().c1d();
  } else {
    tmp = FixedPoolNativeThreadDispatcher.c1y(16, 'AUDIO', Companion_getInstance_0().p1x_1, true);
  }
  return tmp;
}
function AUDIO$factory() {
  return getPropertyCallableRef('AUDIO', 1, KProperty1, function (receiver) {
    return get_AUDIO(receiver);
  }, null);
}
var properties_initialized_Dispatchers_AUDIO_kt_6wdlgz;
function _init_properties_Dispatchers_AUDIO_kt__q7crgv() {
  if (!properties_initialized_Dispatchers_AUDIO_kt_6wdlgz) {
    properties_initialized_Dispatchers_AUDIO_kt_6wdlgz = true;
    AUDIO$delegate = lazy(AUDIO$delegate$lambda);
  }
}
var Companion_instance_2;
function Companion_getInstance_5() {
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
function applyPropsTo(_this__u8e3s4, listener, samples) {
  var inductionVariable = 0;
  var last = samples.h5s_1;
  if (inductionVariable < last)
    do {
      var ch = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var volume01 = volumeForChannel(_this__u8e3s4, listener, ch) * _this__u8e3s4.m5s();
      var inductionVariable_0 = 0;
      var last_0 = samples.i5s_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var sample = samples.l5r(ch, n);
          sample = AudioSample__times_impl_3gw0k9(sample, volume01);
          samples.b5t(ch, n, sample);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function volumeForChannel(_this__u8e3s4, listener, channel) {
  var distance = listener.i5t().e2l(_this__u8e3s4.e1r());
  return channel === 0 ? convertRangeClamped(_this__u8e3s4.o5s(), -1.0, 0.0, 0.0, 1.0) : 1.0 - convertRangeClamped(_this__u8e3s4.o5s(), 0.0, 1.0, 0.0, 1.0);
}
function get_nativeSoundProvider() {
  _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
  // Inline function 'kotlin.getValue' call
  var this_0 = nativeSoundProvider$delegate;
  nativeSoundProvider$factory();
  return this_0.n1();
}
var nativeSoundProvider$delegate;
function *_generator_invoke__zhh2q8_1($this, $this$AudioPlatformOutput, $completion) {
  get_nativeSoundProvider();
  var node = {_v: null};
  var tmp = HtmlSimpleSound_getInstance();
  var startPromise = tmp.q5t(HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda$lambda($this.k5t_1, $this.l5t_1, node, $this$AudioPlatformOutput));
  try {
    var tmp_0 = $this$AudioPlatformOutput.p5s($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }finally {
    if (startPromise == null)
      null;
    else {
      cancel(startPromise);
    }
    var tmp3_safe_receiver = node._v;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.disconnect();
    }
  }
  return Unit_instance;
}
function HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda$lambda$lambda($this_AudioPlatformOutput, $samples, $channels, $bufferSize, $scale) {
  return function (e) {
    $this_AudioPlatformOutput.e5s($samples);
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < $channels) {
      do {
        var ch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var outCh = e.outputBuffer.getChannelData(ch);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < $bufferSize)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'org.khronos.webgl.set' call
            // Inline function 'kotlin.js.asDynamic' call
            outCh[n] = _AudioSample___get_float__impl__o6fgbi(getSampled($samples, ch, n * $scale));
          }
           while (inductionVariable_0 < $bufferSize);
      }
       while (inductionVariable < $channels);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda$lambda($frequency, $channels, $node, $this_AudioPlatformOutput) {
  return function (it) {
    var ctx = HtmlSimpleSound_getInstance().m5t_1;
    var tmp;
    if (!(ctx == null)) {
      var bufferSize = 2048;
      var scale = $frequency / ctx.sampleRate;
      var samples = new AudioSamplesInterleaved($channels, numberToInt(bufferSize * scale));
      $node._v = ctx.createScriptProcessor(bufferSize, $channels, $channels);
      var tmp0_safe_receiver = $node._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.onaudioprocess = HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda$lambda$lambda($this_AudioPlatformOutput, samples, $channels, bufferSize, scale);
      }
      var tmp1_safe_receiver = $node._v;
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver.connect(ctx.destination);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda_0($frequency, $channels) {
  var i = new HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda($frequency, $channels);
  var l = function ($this$AudioPlatformOutput, $completion) {
    return i.g5s($this$AudioPlatformOutput, $completion);
  };
  l.$arity = 1;
  return l;
}
function nativeSoundProvider$delegate$lambda() {
  _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
  var tmp;
  if (Companion_getInstance_1().rv()) {
    tmp = new HtmlNativeSoundProvider();
  } else {
    tmp = Companion_getInstance_5();
  }
  return tmp;
}
function nativeSoundProvider$factory() {
  return getPropertyCallableRef('nativeSoundProvider', 0, KProperty0, function () {
    return get_nativeSoundProvider();
  }, null);
}
var properties_initialized_HtmlNativeSoundProvider_kt_uyp32m;
function _init_properties_HtmlNativeSoundProvider_kt__ocy1lg() {
  if (!properties_initialized_HtmlNativeSoundProvider_kt_uyp32m) {
    properties_initialized_HtmlNativeSoundProvider_kt_uyp32m = true;
    nativeSoundProvider$delegate = lazy(nativeSoundProvider$delegate$lambda);
  }
}
function HtmlSimpleSound$unlockDeferred$lambda$lambda($source, $unlockDeferred) {
  return function () {
    $source.disconnect(0);
    HtmlSimpleSound_getInstance().n5t_1 = true;
    console.info('Web Audio was successfully unlocked');
    $unlockDeferred.k1c(Unit_instance);
    return Unit_instance;
  };
}
function HtmlSimpleSound$unlockDeferred$lambda($events, $unlock, $buf, $unlockDeferred) {
  return function (it) {
    var indexedObject = $events;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var e = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = document;
      var tmp_0;
      if ($unlock._v == null) {
        throwUninitializedPropertyAccessException('unlock');
      } else {
        tmp_0 = $unlock._v;
      }
      tmp.removeEventListener(e, tmp_0, true);
    }
    HtmlSimpleSound_getInstance().m5t_1.resume();
    var source = HtmlSimpleSound_getInstance().m5t_1.createBufferSource();
    source.onended = HtmlSimpleSound$unlockDeferred$lambda$lambda(source, $unlockDeferred);
    source.buffer = $buf;
    source.connect(HtmlSimpleSound_getInstance().m5t_1.destination);
    source.start(0.0);
    HtmlSimpleSound_getInstance().m5t_1.resume();
    return Unit_instance;
  };
}
function HtmlSimpleSound$callOnUnlocked$lambda($cancelled, $callback) {
  return function (it) {
    if (!$cancelled._v)
      $callback(Unit_instance);
    return Unit_instance;
  };
}
function HtmlSimpleSound$callOnUnlocked$lambda_0($cancelled) {
  return function (it) {
    $cancelled._v = true;
    return Unit_instance;
  };
}
var HtmlSimpleSound_instance;
function HtmlSimpleSound_getInstance() {
  if (HtmlSimpleSound_instance === VOID)
    new HtmlSimpleSound();
  return HtmlSimpleSound_instance;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(AudioData, 'AudioData');
initMetadataForCompanion(Companion_0);
initMetadataForLambda(AudioPlatformOutput$_init_$slambda_5e7gu6, VOID, VOID, [1]);
initMetadataForLambda(AudioPlatformOutput$start$slambda, VOID, VOID, [1]);
initMetadataForInterface(ReadonlySoundProps, 'ReadonlySoundProps');
initMetadataForInterface(SoundProps, 'SoundProps', VOID, VOID, [ReadonlySoundProps]);
protoOf(AudioPlatformOutput).s5s = set_pitch;
protoOf(AudioPlatformOutput).t5s = get_pitch_0;
initMetadataForClass(AudioPlatformOutput, 'AudioPlatformOutput', VOID, VOID, [AutoCloseable, SoundProps], [0]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(AudioSample, 'AudioSample');
initMetadataForClass(AudioSampleArray$iterator$1);
initMetadataForClass(AudioSampleArray, 'AudioSampleArray', VOID, VOID, [Collection]);
initMetadataForClass(AudioSamples, 'AudioSamples');
initMetadataForClass(AudioSamplesInterleaved, 'AudioSamplesInterleaved');
initMetadataForInterface(SoundListenerProps, 'SoundListenerProps');
initMetadataForClass(NativeSoundProvider, 'NativeSoundProvider', NativeSoundProvider, VOID, [AutoCloseable, SoundListenerProps]);
initMetadataForClass(DummyNativeSoundProvider, 'DummyNativeSoundProvider', DummyNativeSoundProvider);
initMetadataForCompanion(Companion_2);
initMetadataForLambda(HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda, VOID, VOID, [1]);
initMetadataForClass(HtmlNativeSoundProvider, 'HtmlNativeSoundProvider', HtmlNativeSoundProvider);
initMetadataForClass(sam$korlibs_io_lang_Cancellable$0, 'sam$korlibs_io_lang_Cancellable$0', VOID, VOID, [Cancellable, FunctionAdapter]);
initMetadataForObject(HtmlSimpleSound, 'HtmlSimpleSound', VOID, VOID, VOID, [0, 2, 1]);
//endregion
//region block: init
Companion_instance_0 = new Companion_0();
//endregion
//region block: exports
export {
  AudioSampleArray__fill$default_impl_gh9lh0 as AudioSampleArray__fill$default_impl_gh9lh0607zwvqcotvv,
  _AudioSample___init__impl__s54gd5 as _AudioSample___init__impl__s54gd52xugxuumb5p5l,
  _AudioSample___get_short__impl__uk8ygu as _AudioSample___get_short__impl__uk8ygu25qxorykipf8f,
  _AudioSampleArray___init__impl__qpxoq0 as _AudioSampleArray___init__impl__qpxoq02y04g82w4ty79,
  AudioSampleArray__asShortArray_impl_iyd0md as AudioSampleArray__asShortArray_impl_iyd0md153iqk9vsos7c,
  AudioSampleArray__get_impl_w0l0xc as AudioSampleArray__get_impl_w0l0xc3ifihtwr00dm3,
  AudioSampleArray__set_impl_tqgfwk as AudioSampleArray__set_impl_tqgfwk2e4yme6xw91vg,
  _AudioSampleArray___get_size__impl__8l8tm8 as _AudioSampleArray___get_size__impl__8l8tm8x01vap0727wl,
  Companion_instance_0 as Companion_instance1o81m7d7a4ex,
  Companion_getInstance_4 as Companion_getInstance2wrvcuzneq6bn,
  AudioData as AudioData3ewbxcbopprh8,
  AudioSampleArray as AudioSampleArray262uyoodhuuvf,
  AudioSamples as AudioSamples3pmkh9en9mrjs,
  ReadonlySoundProps as ReadonlySoundProps270enpa6r4amt,
  SoundProps as SoundProps3stqh6vq4ra4p,
  get_nativeSoundProvider as get_nativeSoundProvider1b6rsunmfcp5k,
};
//endregion
